import React, { useState, useEffect } from 'react';
// , { useState }
import styles from './styles.module.less';
import payment from '../../../../common/assets/images/payment_screen.jpg';
import { Row, Col, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import logo from '../../../../common/assets/images/LogoHeaer.png';
// import paymentLogo from '../../../../common/assets/images/payment_success.svg';
import paymentLogo from '../../../../common/assets/images/payment_success.svg';
import { get_Invoice_data } from '../../../ManageProfile/redux/slice';
// LogoHeaer
import { pageview } from '../../../../utilities/gtag';

const Payment = () => {
  useEffect(() => {
    document.title = 'Payment successful - Welcome to your premium membership';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loadingTxn, setLoadingTxn] = useState({});
  const handleNavigate = () => {
    navigate('/dashboard');
    window.location.reload();
  };

  const storedOrder = JSON.parse(localStorage.getItem('order_create'));
  const profile_id = localStorage.getItem('payment_details');
  console.log('Profile ID:', profile_id);

  console.log('Retrieved Order:', storedOrder?.trn);

  const TransactionNum = storedOrder?.trn
    ? `ES-${storedOrder?.trn.slice(0, 8)}`
    : 'N/A';

  const handleViewInvoice = async (txn) => {
    console.log('Transaction ID:', txn); // Debugging
    console.log('Profile ID:', profile_id); // Debugging
    setLoadingTxn((prev) => ({ ...prev, [txn]: true })); // Set loading for the clicked button
    try {
      // setLoading(true);
      // setDisabled(true);
      const response = await dispatch(get_Invoice_data({ id: txn }));

      console.log('API Response:', response); // Debugging

      if (response?.payload?.data) {
        const url = response.payload.data;
        setPdfUrl(url);
        const successMsg =
          response?.payload?.message || 'Invoice loaded successfully!';
        message.success(successMsg);
      } else {
        console.error('Invoice PDF URL not found or empty.');
        const errorMsg =
          response?.payload?.message ||
          'Failed to load invoice. Please try again.';
        message.error(errorMsg);
      }
    } catch (error) {
      console.error('Error fetching invoice:', error);
      const errorMsg =
        error?.response?.data?.message ||
        'An error occurred while fetching the invoice.';
      message.error(errorMsg);
    } finally {
      // setLoading(false);
      // setDisabled(false);
      setLoadingTxn((prev) => ({ ...prev, [txn]: false })); // Reset loading for this transaction
    }
  };

  const rawValue = localStorage.getItem('payment_Amount_GST'); // e.g. "2655000"
  const numberValue = Number(rawValue); // Convert string to number
  const formattedValue = (numberValue / 100).toFixed(2); // Divide by 100 and keep 2 decimal places
  console.log(formattedValue); // Output: "26550.00"

  const currencySymbols = {
    INR: '₹',
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    AUD: 'A$',
    CAD: 'C$'
  };

  return (
    <>
      {/* <Row className={styles.mainContainerStyle}>
        <Col xs={24} xl={11} md={6} sm={6} className={styles.backgroundImg}>
          <img className={`${styles.left_logo}`} src={payment} />
        </Col> */}

      <Row className={styles.mainContainerStyle}>
        <Col xs={24} xl={11} md={6} sm={6} className={styles.backgroundImg}>
          <img className={`${styles.left_logo}`} src={payment} />
        </Col>

        <Col xs={24} xl={13} sm={6} md={6} className={styles.sideheader}>
          <div className={styles.headerload}>
            <img
              src={logo}
              alt="matrimony logo"
              className={styles.logostyles}
            />
          </div>

          <div className={styles.paymentLogo}>
            <img src={paymentLogo} alt="" />
          </div>

          <div className={styles.textcenter}>
            <div className={styles.congo}>
              <div className={styles.con}>Congratulations !!</div>
              <div className={styles.upgrade}>You have now been upgraded </div>
            </div>

            <div className={styles.transfer}>
              <div className={styles.Tnum}>Transaction ID</div>
              <div className={styles.num}> {TransactionNum} </div>
            </div>

            <div className={styles.transfer}>
              <div className={styles.Tnum}>Amount</div>
              <div className={styles.num1}>
                {/* {' '}
                {storedOrder?.currency} {storedOrder?.amount}{' '} */}
                {/* {storedOrder?.currency && storedOrder?.amount
                  ? `${storedOrder.currency} ${storedOrder.amount}`
                  : 'N/A'} */}

                {/* {storedOrder?.currency && formattedValue
                  ? `${storedOrder.currency} ${formattedValue}`
                  : 'N/A'} */}

                {currencySymbols[storedOrder?.currency] ||
                (storedOrder?.currency && formattedValue)
                  ? `${
                      currencySymbols[storedOrder?.currency] ||
                      storedOrder?.currency
                    } ${formattedValue}`
                  : 'N/A'}
              </div>
            </div>
            <div className={styles.transfer}>
              <Button
                type="link"
                className={styles.viewInvoice}
                onClick={() => handleViewInvoice(profile_id)}
                loading={loadingTxn[profile_id] || false} // Loader will show when clicking
                disabled={loadingTxn[profile_id] || false} // Button disabled during API call
              >
                <u>Download Invoice</u>
              </Button>
            </div>

            <Button
              type="primary"
              htmlType="submit"
              className={styles.submitbutton}
              onClick={handleNavigate}
            >
              Back to Home
            </Button>
          </div>
          {/* </Col>
        <Col getter={24}> */}
        </Col>
      </Row>
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          style={{ border: 'none' }}
        />
      )}
      <div></div>
      <div></div>
    </>
  );
};

export default Payment;
